import React from "react";
import { AiOutlineNotification, AiOutlineTeam } from "react-icons/ai";
import { FaBusAlt, FaRoute, FaUsers } from "react-icons/fa";
import { Card, CardTitle, KpiStatTile, LinkRow, SectionShell } from "../blocks";
import { SECTION_COLORS } from "../chartTheme";

const ACCENT = SECTION_COLORS.operations;

const OperationsSection = ({ overview, onNavigate }) => {
  const buses = overview.transport?.buses || 0;
  const routes = overview.transport?.activeRoutes || 0;
  const riders = overview.transport?.transportStudents || 0;
  const ridersPerBus = buses > 0 ? Math.round(riders / buses) : 0;
  const ridersPerRoute = routes > 0 ? Math.round(riders / routes) : 0;
  const transportShare =
    overview.totalStudents > 0
      ? Math.round((riders / overview.totalStudents) * 100)
      : 0;

  return (
    <SectionShell
      id="operations"
      title="Operations"
      subtitle="Transport fleet & communications"
      accentColor={ACCENT}
    >
      <div className="k360-grid k360-cols-2-4 k360-mb">
        <KpiStatTile
          title="Buses"
          value={buses}
          caption="In fleet"
          icon={<FaBusAlt size={16} />}
          chipClass="bg-cyan-50 text-cyan-600"
          accentColor={ACCENT}
        />
        <KpiStatTile
          title="Routes"
          value={routes}
          caption="Active routes"
          icon={<FaRoute size={16} />}
          chipClass="bg-sky-50 text-sky-700"
          accentColor={ACCENT}
        />
        <KpiStatTile
          title="Riders"
          value={riders}
          caption={`${transportShare}% of all students`}
          icon={<AiOutlineTeam size={17} />}
          chipClass="bg-emerald-50 text-emerald-600"
          captionClass="text-emerald-600 font-semibold"
          accentColor={ACCENT}
        />
        <KpiStatTile
          title="Announcements"
          value={overview.announcementsThisMonth || 0}
          caption="Published this month"
          icon={<AiOutlineNotification size={16} />}
          chipClass="bg-violet-50 text-violet-600"
          accentColor={ACCENT}
        />
      </div>

      <div className="k360-grid k360-cols-2">
        <Card accentColor={ACCENT}>
          <CardTitle
            title="Transport Utilization"
            subtitle="Average riders per vehicle & route"
            extra={
              <button
                onClick={() =>
                  onNavigate("/dashboard/admin/menu/transportation/")
                }
                className="text-xs font-semibold text-primary hover:underline"
              >
                Manage transportation →
              </button>
            }
          />
          <div className="k360-grid" style={{ gridTemplateColumns: "repeat(2, minmax(0, 1fr))" }}>
            <KpiStatTile
              title="Avg. Riders / Bus"
              value={ridersPerBus}
              caption="Utilization per vehicle"
              icon={<FaUsers size={15} />}
              chipClass="bg-cyan-50 text-cyan-600"
              accentColor={ACCENT}
            />
            <KpiStatTile
              title="Avg. Riders / Route"
              value={ridersPerRoute}
              caption="Utilization per route"
              icon={<FaRoute size={15} />}
              chipClass="bg-sky-50 text-sky-700"
              accentColor={ACCENT}
            />
          </div>
        </Card>

        <Card accentColor={ACCENT}>
          <CardTitle
            title="Communications"
            subtitle="School-wide announcements"
          />
          <LinkRow
            icon={<AiOutlineNotification size={16} />}
            iconBg="#f5f3ff"
            iconColor="#8b5cf6"
            label="View announcements"
            caption={`${overview.announcementsThisMonth || 0} published this month`}
            onClick={() => onNavigate("/dashboard/admin/menu/message")}
          />
        </Card>
      </div>
    </SectionShell>
  );
};

export default OperationsSection;
